<template>
  <section>
    <gs-header title="Bảng điều khiển">
    </gs-header>
    <div class="padding-sm-all">
      <el-row :gutter="5" class="remove-margin margin-sm-top">
        <el-col :span="14" :xs="0">&nbsp;</el-col>
        <el-col :span="5" :xs="24" class="margin-sm-bottom">
          <el-date-picker size="small" class="width-100" v-model="filterDateRange" type="daterange" range-separator=" / "
            @input="updateFilters" format="dd-MM-yyyy" start-placeholder="Từ ngày" end-placeholder="Đến ngày">
          </el-date-picker>
        </el-col>
        <!-- <el-col :span="5">
        <el-select :clearable="true" class="display-block " v-model="filters.carrier_id" @change="filter" filterable placeholder="Chọn hãng vận chuyển">
          <el-option
            v-for="carrier in carriers"
            :key="carrier.id"
            :label="carrier.name"
            :value="carrier.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-select v-model="filters.status" placeholder="Chọn trạng thái" class="display-block" @change="filter">
          <el-option class="text-blue" label="Tất cả" :value="-1"></el-option>
          <el-option v-for="(status, index) in shipmentHelpers.statuses" :class="{[shipmentStatuses[status.status]]: filters.status !== status.status}" :key="index" :label="status.status_txt" :value="status.status" v-if="status.status !== -1"></el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-select v-model="filters.sale_id" filterable placeholder="Chọn saler" @change="filter" class="width-100">
          <el-option
            v-for="admin in administrators"
            :key="admin.id"
            :label="admin.name"
            :value="admin.id">
          </el-option>
        </el-select>
      </el-col> -->
        <!-- <el-col :span="4">
        <el-radio-group class="status-listting margin-lg-right" v-model="filters.vip" @change="filter" :fill="filters.vip === 1 ? '#32CD32' : filters.vip === 0 ? '#FE9A76' : '#0E6EB8'">
          <el-radio-button :label="1"><span :class="{'text-green' : filters.vip !== 1}">VIP</span></el-radio-button>
          <el-radio-button :label="0"><span :class="{'text-orange' : filters.vip !== 0}">Thường</span></el-radio-button>
          <el-radio-button label=""><span :class="{'text-blue' : filters.vip !== ''}">Tất cả</span></el-radio-button>
        </el-radio-group>
      </el-col> -->
        <el-col :span="5" :xs="24">
          <el-radio-group v-model="view" @change="changeView" size="small">
            <el-radio-button label="day">Ngày</el-radio-button>
            <el-radio-button label="week">Tuần</el-radio-button>
            <el-radio-button label="month">Tháng</el-radio-button>
            <el-radio-button label="year">Năm</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="remove-margin margin-top">
        <el-col :span="24">
          <h2>Biểu đồ biểu diễn theo thời gian</h2>
        </el-col>
        <el-col :span="12" :xs="24">
          <div id="statistic-proportion"></div>
        </el-col>
        <el-col :span="12" :xs="24">
          <div id="statistic-client"></div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="remove-margin margin-top">
        <el-col :span="12" :xs="24">
          <div id="statistic-cod-amount"></div>
        </el-col>
        <el-col :span="12" :xs="24">
          <div id="statistic-profit"></div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="remove-margin margin-top">
        <el-col :span="24">
          <h2>Biểu đồ phân bổ theo thời gian</h2>
        </el-col>
        <el-col :span="12" :xs="24">
          <div id="statistic-total-shop"></div>
        </el-col>
        <el-col :span="12" :xs="24">
          <div id="statistic-total-source"></div>
        </el-col>
        <el-col :span="12" :xs="24" class="margin-lg-top">
          <div id="statistic-carrier-pie"></div>
        </el-col>
        <el-col :span="12" :xs="24">
          <div id="statistic-proportion-pie"></div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="remove-margin margin-top">
        <el-col :span="24">
          <h2>Thống kê hoạt động của người dùng</h2>
        </el-col>
        <el-col :span="12" :xs="24">
          <p class="header text-center">10 Khách hàng có số lượng đơn cao nhất <a href=""
              @click.prevent="drawAllUserHasShipment"><small>(Xem tất cả)</small></a></p>
          <p class="sub-header text-center">
            10 Khách hàng có số lượng đơn cao nhất
            <span v-if="filters.start_date && filters.end_date">{{ ` từ ngày ${formatDate(this.filters.start_date,
              'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}` }}</span>
            <span v-else>{{ ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY') }}</span>
          </p>
          <el-table :data="topUserAllShipment" stripe border style="width: 100%">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column label="Khách hàng">
              <template slot-scope="scope">
                <span v-if="scope.row.client">{{ scope.row.client.data.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Tổng đơn" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.total_shipment | number }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Đơn thành công" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.total_success | number }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Tỉ lệ" width="100">
              <template slot-scope="scope">
                <span>{{ (scope.row.total_success / scope.row.total_shipment) * 100 | percent(2) }}</span>
                <a href="#" @click.prevent="showDetailShop(scope.row)" class="text-blue cursor-pointer pull-right"><i
                    class="fa fa-search"></i></a>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12" :xs="24">
          <p class="header text-center">10 Khách hàng có số lượng đơn chuyển hoàn cao nhất</p>
          <p class="sub-header text-center">
            10 Khách hàng có số lượng đơn chuyển hoàn cao nhất
            <span v-if="filters.start_date && filters.end_date">{{ ` từ ngày ${formatDate(this.filters.start_date,
              'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}` }}</span>
            <span v-else>{{ ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY') }}</span>
          </p>
          <el-table :data="topUserReturnShipment" stripe border style="width: 100%">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column label="Khách hàng">
              <template slot-scope="scope">
                <span v-if="scope.row.client">{{ scope.row.client.data.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Tổng đơn" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.total_shipment | number }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Đơn chuyển hoàn" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.total_return | number }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Tỉ lệ" width="100">
              <template slot-scope="scope">
                <span>{{ (scope.row.total_return / scope.row.total_shipment) * 100 | percent }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12" :xs="24">
          <p class="header text-center">10 quận có lượng đơn cao nhất</p>
          <p class="sub-header text-center">
            10 quận có lượng đơn cao nhất
            <span v-if="filters.start_date && filters.end_date">{{ ` từ ngày ${formatDate(this.filters.start_date,
              'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}` }}</span>
            <span v-else>{{ ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY') }}</span>
          </p>
          <el-table :data="topDistrictTopShipment" stripe border style="width: 100%">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column label="Quận">
              <template slot-scope="scope">
                {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column label="Tổng đơn" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.total_shipment | number }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12" :xs="24">
          <p class="header text-center">10 quận có lượng khách hàng cao nhất</p>
          <p class="sub-header text-center">
            10 quận có lượng khách hàng cao nhất
            <span v-if="filters.start_date && filters.end_date">{{ ` từ ngày ${formatDate(this.filters.start_date,
              'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}` }}</span>
            <span v-else>{{ ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY') }}</span>
          </p>
          <el-table :data="topDistrictTopUser" stripe border style="width: 100%">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column label="Quận">
              <template slot-scope="scope">
                {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column label="Khách hàng" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.total_user | number }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12" :xs="24">
          <p class="header text-center">Thống kê đơn theo tỉnh thành</p>
          <p class="sub-header text-center">
            Thống kê đơn theo tỉnh thành
            <span v-if="filters.start_date && filters.end_date">{{ ` từ ngày ${formatDate(this.filters.start_date,
              'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}` }}</span>
            <span v-else>{{ ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY') }}</span>
          </p>
          <el-table :data="[].concat(matrixShipmentByCity, interprovinceShipment)" stripe border style="width: 100%">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column label="Thời gian">
              <template slot-scope="scope">
                {{ scope.row.create_time }}
              </template>
            </el-table-column>
            <el-table-column label="Tỉnh thành đi">
              <template slot-scope="scope">
                {{ scope.row.city_from_name ? scope.row.city_from_name : scope.row.city_from }}
              </template>
            </el-table-column>
            <el-table-column label="Tỉnh thành đến">
              <template slot-scope="scope">
                {{ scope.row.city_to_name ? scope.row.city_to_name : 'Liên tỉnh' }}
              </template>
            </el-table-column>
            <el-table-column label="Vận đơn" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.total_shipment | number }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Phí vận chuyển" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.total_location_fee / 1000 | number }} k</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <!-- <el-col :span="12" :xs="24">
        <p class="header text-center">Thống kê đơn liên tỉnh</p>
        <p class="sub-header text-center">
          Thống kê đơn liên tỉnh
          <span v-if="filters.start_date && filters.end_date">{{` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`}}</span>
          <span v-else>{{' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')}}</span>
        </p>
        <el-table
          :data="interprovinceShipment"
          stripe
          border
          style="width: 100%">
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            label="Thời gian">
              <template slot-scope="scope">
                {{scope.row.create_time}}
              </template>
          </el-table-column>
          <el-table-column
            label="Tỉnh thành">
              <template slot-scope="scope">
                {{scope.row.city_from}}
              </template>
          </el-table-column>
          <el-table-column
            label="Vận đơn"
            width="150">
              <template slot-scope="scope">
                <span>{{scope.row.total_shipment | number}}</span>
              </template>
          </el-table-column>
        </el-table>
      </el-col> -->
        <el-col :span="12" :xs="24">
          <p class="header text-center">Thống kê đơn gửi từ tỉnh thành</p>
          <p class="sub-header text-center">
            Thống kê đơn gửi từ tỉnh thành
            <span v-if="filters.start_date && filters.end_date">{{ ` từ ngày ${formatDate(this.filters.start_date,
              'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}` }}</span>
            <span v-else>{{ ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY') }}</span>
          </p>
          <el-table :data="allShipmentFromCity" stripe border style="width: 100%">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column label="Thời gian">
              <template slot-scope="scope">
                {{ scope.row.create_time }}
              </template>
            </el-table-column>
            <el-table-column label="Tỉnh thành">
              <template slot-scope="scope">
                {{ scope.row.city_from }}
              </template>
            </el-table-column>
            <el-table-column label="Vận đơn" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.total_shipment | number }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- <el-col :span="8" class="margin-lg-top">
        <div id="statistic-carrier"></div>
      </el-col> -->
      <!--  <el-col :span="24">
        <div id="statistic-status-by-day"></div>
      </el-col> -->
      <!-- <el-col :span="24">
        <div id="statistic-status"></div>
      </el-col> -->
    </div>
    <el-dialog :title="`Thông tin shop: ${currentShop.shop_name}`" :visible.sync="detailShopModal">
      <el-row>
        <el-col :span="24">
          <div id="statistic-detail-shopment-shop"></div>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog title="Danh sách khách hàng tạo đơn" :visible.sync="allUserHasShipmentModal">
      <el-row>
        <el-col :span="24">
          <el-table :data="allUserHasShipment" stripe border style="width: 100%">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column label="Khách hàng">
              <template slot-scope="scope">
                <span v-if="scope.row.client">{{ scope.row.client.data.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Tổng đơn" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.total_shipment | number }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Đơn thành công" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.total_success | number }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Tỉ lệ" width="100">
              <template slot-scope="scope">
                <span>{{ (scope.row.total_success / scope.row.total_shipment) * 100 | percent(2) }}</span>
                <a href="#" @click.prevent="showDetailShop(scope.row)" class="text-blue cursor-pointer pull-right"><i
                    class="fa fa-search"></i></a>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>

  </section>
</template>

<script>
import Highcharts from 'highcharts'
import {
  getByStatus,
  getByTime,
  getClientByDay,
  getTop10User,
  getProportion,
  getTotalCod,
  getProfit,
  getProportionPie,
  getByCarrier,
  getTotalShop,
  getTotalSource,
  getAllUserHasShipments,
  getByCarrierPie,
  getTop10DistrictTopShipment,
  getTop10DistrictTopUser,
  getMatrixShipmentByCity,
  getInterprovinceShipment,
  getAllShipmentFromCity
} from 'src/api/dashboard'
import { shipmentStatuses, shipmentStatusesBg } from 'src/stubs/shipments'
import { carrierShortName } from 'src/stubs/carrier'
import { forEach } from 'lodash'
import { formatDate } from 'src/helpers'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'dashboard',
  data() {
    return {
      carrierShortName: carrierShortName,
      shipmentStatuses: shipmentStatuses,
      filterDateRange: '',
      filters: {
        start_date: moment().date(1).format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        status: -1,
        carrier_id: '',
        sale_id: '',
        vip: ''
      },
      topUserAllShipment: [],
      topUserReturnShipment: [],
      allUserHasShipment: [],
      view: 'day',
      detailShopModal: false,
      detailShipmentShop: {},
      currentShop: {},
      allUserHasShipmentModal: false,
      topDistrictTopShipment: [],
      topDistrictTopUser: [],
      matrixShipmentByCity: [],
      interprovinceShipment: [],
      allShipmentFromCity: []
    }
  },
  computed: {
    ...mapGetters('carrier', ['carriers']),
    ...mapGetters('shipment', ['shipmentHelpers']),
    ...mapGetters('admin', ['administrators'])
  },
  methods: {
    ...mapActions('carrier', ['getAllCarriers']),
    ...mapActions('shipment', ['getShipmentHelpers']),
    ...mapActions('admin', ['getAllAdmins']),
    updateFilters(data) {
      if (formatDate(data[0]) === this.filters.start_date && formatDate(data[1]) === this.filters.end_date) {
        return false
      }
      this.filters.start_date = formatDate(data[0])
      this.filters.end_date = formatDate(data[1])
      this.filter()
    },
    filter() {
      // this.drawStatisticStatus()
      // this.drawStatisticByTime()
      this.drawStatisticClientByDay()
      this.drawTop10UserWithAllShipment()
      this.drawTop10UserWithReturnShipment()
      this.drawProportion()
      this.drawProportionPie()
      this.drawStatisticCodAmount()
      this.drawProfit()
      this.drawByCarierPie()
      // this.drawByCarrier()
      this.drawTotalShop()
      this.drawTotalSource()
      this.drawTop10DistrictTopShipment()
      this.drawTop10DistrictTopUser()
      this.drawMatrixShipmentByCity()
      this.drawInterprovinceShipment()
      this.drawAllShipmentFromCity()
    },
    changeView() {
      // this.drawStatisticByTime()
      this.drawStatisticClientByDay()
      this.drawStatisticCodAmount()
      this.drawProfit()
      this.drawProportion()
      this.drawMatrixShipmentByCity()
      this.drawInterprovinceShipment()
      this.drawAllShipmentFromCity()
    },
    formatDate(data, format = 'DD-MM-YYYY') {
      return formatDate(data, format)
    },
    drawStatisticStatus() {
      this.toggleLoadding(true)
      let filters = Object.assign({}, this.filters)
      filters.view = this.view
      getByStatus(filters).then(response => {
        this.toggleLoadding(false)
        let title = 'Số lượng vận đơn theo trạng thái'
        if (this.filters.start_date && this.filters.end_date) {
          title += ` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`
        } else {
          title += ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')
        }
        if (response.code === 200) {
          let colors = []
          forEach(response.data.statuses, (value, key) => {
            if (value === -1) {
              colors.push('#0E6EB8')
            } else {
              colors.push(shipmentStatusesBg[value])
            }
          })
          let chart = new Highcharts.Chart({
            chart: {
              renderTo: 'statistic-status',
              type: 'column'
            },
            title: {
              text: 'Số lượng vận đơn theo trạng thái'
            },
            subtitle: {
              text: title
            },
            xAxis: {
              categories: response.data.categories,
              crosshair: true
            },
            yAxis: {
              allowDecimals: false,
              min: 0,
              title: {
                text: 'Số vận đơn (vận đơn)'
              }
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.0f} vận đơn</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              },
              series: {
                colorByPoint: true,
                colors: colors
              }
            },
            series: [{
              showInLegend: false,
              name: 'Vận đơn',
              data: response.data.series.data
            }]
          })
          window.chart = chart
        } else {
          document.getElementById('statistic-status').innerHTML = ''
        }
      })
    },
    drawStatisticByTime() {
      this.toggleLoadding(true)
      let filters = Object.assign({}, this.filters)
      filters.view = this.view
      getByTime(filters).then(response => {
        this.toggleLoadding(false)
        let title = 'Số lượng vận đơn theo thời gian'
        if (this.filters.start_date && this.filters.end_date) {
          title += ` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`
        } else {
          title += ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')
        }
        if (response.code === 200) {
          let chart = new Highcharts.Chart({
            chart: {
              renderTo: 'statistic-status-by-day',
              type: 'line'
            },
            title: {
              text: 'Số lượng vận đơn theo thời gian'
            },
            subtitle: {
              text: title
            },
            xAxis: {
              categories: response.data.categories,
              crosshair: true
            },
            yAxis: {
              allowDecimals: false,
              min: 0,
              title: {
                text: 'Số vận đơn (vận đơn)'
              }
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.0f} vận đơn</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              },
              series: {
                colorByPoint: true,
                colors: this.filters.status === -1 ? ['#0E6EB8'] : [shipmentStatusesBg[this.filters.status]],
                lineColor: this.filters.status === -1 ? '#0E6EB8' : shipmentStatusesBg[this.filters.status]
              }
            },
            series: [{
              showInLegend: false,
              name: 'Vận đơn',
              data: response.data.series.data
            }]
          })
          window.chart = chart
        } else {
          document.getElementById('statistic-status-by-day').innerHTML = ''
        }
      })
    },
    drawStatisticClientByDay() {
      this.toggleLoadding(true)
      let filters = Object.assign({}, this.filters)
      filters.view = this.view
      getClientByDay(filters).then(response => {
        this.toggleLoadding(false)
        let title = 'Số lượng shop đăng ký theo thời gian'
        if (this.filters.start_date && this.filters.end_date) {
          title += ` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`
        } else {
          title += ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')
        }
        if (response.code === 200) {
          let chart = new Highcharts.Chart({
            chart: {
              renderTo: 'statistic-client',
              type: 'line'
            },
            title: {
              text: 'Số lượng shop đăng ký theo thời gian'
            },
            subtitle: {
              text: title
            },
            xAxis: {
              categories: response.data.categories,
              crosshair: true
            },
            yAxis: {
              allowDecimals: false,
              min: 0,
              title: {
                text: 'Số shop (shop)'
              }
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.0f} shop</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              }
            },
            series: response.data.series
          })
          window.chart = chart
        } else {
          document.getElementById('statistic-status-by-day').innerHTML = ''
        }
      })
    },
    drawTop10UserWithAllShipment() {
      let filters = Object.assign({}, this.filters)
      this.toggleLoadding(true)
      getTop10User(filters).then(response => {
        if (response.code === 200) {
          this.topUserAllShipment = response.data
          this.toggleLoadding(false)
        } else {
          this.topUserAllShipment = []
          this.toggleLoadding(false)
        }
      })
    },
    drawTop10UserWithReturnShipment() {
      let filters = Object.assign({}, this.filters)
      filters.is_return = true
      this.toggleLoadding(true)
      getTop10User(filters).then(response => {
        if (response.code === 200) {
          this.toggleLoadding(false)
          this.topUserReturnShipment = response.data
        } else {
          this.topUserReturnShipment = []
          this.toggleLoadding(false)
        }
      })
    },
    drawAllUserHasShipment() {
      let filters = Object.assign({}, this.filters)
      this.toggleLoadding(true)
      getAllUserHasShipments(filters).then(response => {
        if (response.code === 200) {
          this.toggleLoadding(false)
          this.allUserHasShipment = response.data
          this.allUserHasShipmentModal = true
        } else {
          this.allUserHasShipment = []
          this.toggleLoadding(false)
          this.allUserHasShipmentModal = true
        }
      })
    },
    drawProportion() {
      let filters = Object.assign({}, this.filters)
      filters.view = this.view
      getProportion(filters).then(response => {
        let title = 'Tỷ lệ phân bố vận đơn theo thời gian'
        if (this.filters.start_date && this.filters.end_date) {
          title += ` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`
        } else {
          title += ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')
        }
        if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
          let chart = new Highcharts.Chart({
            chart: {
              renderTo: 'statistic-proportion',
              type: 'line'
            },
            title: {
              text: 'Tỷ lệ phân bố vận đơn theo thời gian',
              x: -20
            },
            subtitle: {
              text: title,
              x: -20
            },
            xAxis: {
              categories: response.data.categories
            },
            yAxis: {
              title: {
                text: 'Vận đơn'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.0f} đơn</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              align: 'right',
              verticalAlign: 'bottom'
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              }
            },
            series: response.data.series
          })
          this.log = chart
        } else {
          document.getElementById('statistic-proportion').innerHTML = ''
        }
      })
    },
    drawStatisticCodAmount() {
      this.toggleLoadding(true)
      let filters = Object.assign({}, this.filters)
      filters.view = this.view
      getTotalCod(filters).then(response => {
        this.toggleLoadding(false)
        let title = 'Tổng tiền COD theo thời gian'
        if (this.filters.start_date && this.filters.end_date) {
          title += ` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`
        } else {
          title += ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')
        }
        if (response.code === 200) {
          let chart = new Highcharts.Chart({
            chart: {
              renderTo: 'statistic-cod-amount',
              type: 'line'
            },
            title: {
              text: 'Tổng tiền COD theo thời gian'
            },
            subtitle: {
              text: title
            },
            xAxis: {
              categories: response.data.categories,
              crosshair: true
            },
            yAxis: {
              title: {
                text: 'VNĐ'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b class="text-red">{point.y}</b>đ</td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            plotOptions: {
              line: {
                showInLegend: true
              }
            },
            series: response.data.series
          })
          window.chart = chart
        } else {
          document.getElementById('statistic-cod-amount').innerHTML = ''
        }
      })
    },
    drawProfit() {
      this.toggleLoadding(true)
      let filters = Object.assign({}, this.filters)
      filters.view = this.view
      getProfit(filters).then(response => {
        this.toggleLoadding(false)
        let title = 'Tổng doanh thu theo thời gian'
        if (this.filters.start_date && this.filters.end_date) {
          title += ` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`
        } else {
          title += ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')
        }
        if (response.code === 200) {
          let chart = new Highcharts.Chart({
            chart: {
              renderTo: 'statistic-profit',
              type: 'line'
            },
            title: {
              text: 'Tổng doanh thu theo thời gian'
            },
            subtitle: {
              text: title
            },
            xAxis: {
              categories: response.data.categories,
              crosshair: true
            },
            yAxis: {
              title: {
                text: 'VNĐ'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b class="text-red">{point.y}</b>đ</td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            plotOptions: {
              line: {
                showInLegend: true
              }
            },
            series: response.data.series
          })
          window.chart = chart
        } else {
          document.getElementById('statistic-cod-amount').innerHTML = ''
        }
      })
    },
    drawProportionPie() {
      getProportionPie(this.filters).then(response => {
        let title = 'Tỷ lệ phân bố vận đơn theo thời gian'
        if (this.filters.start_date && this.filters.end_date) {
          title += ` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`
        } else {
          title += ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')
        }
        if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
          let chart = new Highcharts.Chart({
            chart: {
              renderTo: 'statistic-proportion-pie',
              type: 'pie'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: false
                },
                showInLegend: true
              },
              series: {
                dataLabels: {
                  enabled: true,
                  format: '{point.name}: {point.percentage:.1f}%'
                }
              }
            },
            title: {
              text: 'Tỷ lệ phân bố vận đơn',
              x: -20
            },
            subtitle: {
              text: title,
              x: -20
            },
            xAxis: {
              categories: response.data.categories
            },
            yAxis: {
              title: {
                text: 'Vận đơn'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>' +
                '<tr><td style="padding:0">Tỷ lệ:</td><td style="padding:0"><b>{point.percentage:.1f}</b>%</td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              align: 'right',
              verticalAlign: 'bottom'
            },
            series: response.data.series
          })
          this.log = chart
        } else {
          document.getElementById('statistic-proportion-pie').innerHTML = ''
        }
      })
    },
    drawByCarrier() {
      getByCarrier(this.filters).then(response => {
        let title = 'Tỷ lệ phân bố vận đơn theo hãng vận chuyển'
        if (this.filters.start_date && this.filters.end_date) {
          title += ` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`
        } else {
          title += ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')
        }
        if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
          let chart = new Highcharts.Chart({
            chart: {
              renderTo: 'statistic-carrier',
              type: 'column'
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              }
            },
            title: {
              text: 'Tỷ lệ phân bố vận đơn theo hãng vận chuyển',
              x: -20
            },
            subtitle: {
              text: title,
              x: -20
            },
            xAxis: {
              categories: response.data.categories
            },
            yAxis: {
              title: {
                text: 'Vận đơn'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              align: 'right',
              verticalAlign: 'bottom'
            },
            series: response.data.series
          })
          this.log = chart
        } else {
          document.getElementById('statistic-carrier').innerHTML = ''
        }
      })
    },
    drawTotalShop() {
      getTotalShop(this.filters).then(response => {
        let title = 'Tỷ lệ phân bố shop theo vùng miền'
        if (this.filters.start_date && this.filters.end_date) {
          title += ` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`
        } else {
          title += ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')
        }
        if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
          let chart = new Highcharts.Chart({
            chart: {
              renderTo: 'statistic-total-shop',
              type: 'pie'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: false
                },
                showInLegend: true
              },
              series: {
                dataLabels: {
                  enabled: true,
                  format: '{point.name}: {point.percentage:.1f}%'
                }
              }
            },
            title: {
              text: 'Tỷ lệ phân bố shop theo vùng miền',
              x: -20
            },
            subtitle: {
              text: title,
              x: -20
            },
            xAxis: {
              categories: response.data.categories
            },
            yAxis: {
              title: {
                text: 'Shop'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>' +
                '<tr><td style="padding:0">Tỷ lệ:</td><td style="padding:0"><b>{point.percentage:.1f}</b>%</td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              align: 'right',
              verticalAlign: 'bottom'
            },
            series: response.data.series
          })
          this.log = chart
        } else {
          if (document.getElementById('statistic-total-shop')) {
            document.getElementById('statistic-total-shop').innerHTML = ''
          }
        }
      })
    },
    drawTotalSource() {
      getTotalSource(this.filters).then(response => {
        let title = 'Tỷ lệ phân bố vận đơn theo nguồn tạo đơn'
        if (this.filters.start_date && this.filters.end_date) {
          title += ` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`
        } else {
          title += ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')
        }
        if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
          let chart = new Highcharts.Chart({
            chart: {
              renderTo: 'statistic-total-source',
              type: 'pie'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: false
                },
                showInLegend: true
              },
              series: {
                dataLabels: {
                  enabled: true,
                  format: '{point.name}: {point.percentage:.1f}%'
                }
              }
            },
            title: {
              text: 'Tỷ lệ phân bố vận đơn theo nguồn tạo đơn',
              x: -20
            },
            subtitle: {
              text: title,
              x: -20
            },
            xAxis: {
              categories: response.data.categories
            },
            yAxis: {
              title: {
                text: 'Shop'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>' +
                '<tr><td style="padding:0">Tỷ lệ:</td><td style="padding:0"><b>{point.percentage:.1f}</b>%</td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              align: 'right',
              verticalAlign: 'bottom'
            },
            series: response.data.series
          })
          this.log = chart
        } else {
          document.getElementById('statistic-total-source').innerHTML = ''
        }
      })
    },
    drawByCarierPie() {
      getByCarrierPie(this.filters).then(response => {
        let title = 'Tỷ lệ phân bố vận đơn theo hãng vận chuyển'
        if (this.filters.start_date && this.filters.end_date) {
          title += ` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`
        } else {
          title += ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')
        }
        if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
          let chart = new Highcharts.Chart({
            chart: {
              renderTo: 'statistic-carrier-pie',
              type: 'pie'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: false
                },
                showInLegend: true
              },
              series: {
                dataLabels: {
                  enabled: true,
                  format: '{point.name}: {point.percentage:.1f}%'
                }
              }
            },
            title: {
              text: 'Tỷ lệ phân bố vận đơn theo hãng vận chuyển',
              x: -20
            },
            subtitle: {
              text: title,
              x: -20
            },
            xAxis: {
              categories: response.data.categories
            },
            yAxis: {
              title: {
                text: 'Vận đơn'
              },
              allowDecimals: false,
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>' +
                '<tr><td style="padding:0">Tỷ lệ:</td><td style="padding:0"><b>{point.percentage:.1f}</b>%</td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              align: 'right',
              verticalAlign: 'bottom'
            },
            series: response.data.series
          })
          this.log = chart
        } else {
          document.getElementById('statistic-carrier-pie').innerHTML = ''
        }
      })
    },
    showDetailShop(shop) {
      if (shop.client && shop.client.data.id) {
        this.currentShop = shop.client.data
        let filters = Object.assign({}, this.filters)
        filters.view = this.view
        filters.client_id = shop.client.data.id
        getProportion(filters).then(response => {
          if (response.code === 200) {
            this.detailShopModal = true
            let title = 'Tỷ lệ phân bố vận đơn theo thời gian'
            if (this.filters.start_date && this.filters.end_date) {
              title += ` từ ngày  ${formatDate(this.filters.start_date, 'DD-MM-YYYY')} đến ngày ${formatDate(this.filters.end_date, 'DD-MM-YYYY')}`
            } else {
              title += ' ngày ' + formatDate(new Date(), 'DD-MM-YYYY')
            }
            if (typeof response.data.categories !== 'undefined' && response.data.categories.length) {
              this.$nextTick(() => {
                let chart = new Highcharts.Chart({
                  chart: {
                    renderTo: 'statistic-detail-shopment-shop',
                    type: 'line'
                  },
                  title: {
                    text: 'Tỷ lệ phân bố vận đơn theo thời gian',
                    x: -20
                  },
                  subtitle: {
                    text: title,
                    x: -20
                  },
                  xAxis: {
                    categories: response.data.categories
                  },
                  yAxis: {
                    title: {
                      text: 'Vận đơn'
                    },
                    allowDecimals: false,
                    plotLines: [{
                      value: 0,
                      width: 1,
                      color: '#808080'
                    }]
                  },
                  tooltip: {
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                      '<td style="padding:0"><b>{point.y:.0f} đơn</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                  },
                  legend: {
                    align: 'right',
                    verticalAlign: 'bottom'
                  },
                  plotOptions: {
                    column: {
                      pointPadding: 0.2,
                      borderWidth: 0
                    }
                  },
                  series: response.data.series
                })
                this.log = chart
              })
            } else {
              document.getElementById('statistic-detail-shopment-shop').innerHTML = ''
            }
          }
        })
      }
    },
    drawTop10DistrictTopShipment() {
      let filters = Object.assign({}, this.filters)
      this.toggleLoadding(true)
      getTop10DistrictTopShipment(filters).then(response => {
        if (response.code === 200) {
          this.topDistrictTopShipment = response.data
          this.toggleLoadding(false)
        } else {
          this.topDistrictTopShipment = []
          this.toggleLoadding(false)
        }
      })
    },
    drawTop10DistrictTopUser() {
      let filters = Object.assign({}, this.filters)
      this.toggleLoadding(true)
      getTop10DistrictTopUser(filters).then(response => {
        if (response.code === 200) {
          this.topDistrictTopUser = response.data
          this.toggleLoadding(false)
        } else {
          this.topDistrictTopUser = []
          this.toggleLoadding(false)
        }
      })
    },
    drawMatrixShipmentByCity() {
      let filters = Object.assign({}, this.filters)
      filters.view = this.view
      this.toggleLoadding(true)
      getMatrixShipmentByCity(filters).then(response => {
        if (response.code === 200) {
          this.matrixShipmentByCity = response.data
          this.toggleLoadding(false)
        } else {
          this.matrixShipmentByCity = []
          this.toggleLoadding(false)
        }
      })
    },
    drawInterprovinceShipment() {
      let filters = Object.assign({}, this.filters)
      filters.view = this.view
      this.toggleLoadding(true)
      getInterprovinceShipment(filters).then(response => {
        if (response.code === 200) {
          this.interprovinceShipment = response.data
          this.toggleLoadding(false)
        } else {
          this.interprovinceShipment = []
          this.toggleLoadding(false)
        }
      })
    },
    drawAllShipmentFromCity() {
      let filters = Object.assign({}, this.filters)
      filters.view = this.view
      this.toggleLoadding(true)
      getAllShipmentFromCity(filters).then(response => {
        if (response.code === 200) {
          this.allShipmentFromCity = response.data
          this.toggleLoadding(false)
        } else {
          this.allShipmentFromCity = []
          this.toggleLoadding(false)
        }
      })
    }
  },
  mounted() {
    if (!this.carriers.length) {
      this.getAllCarriers({ limit: -1 })
    }
    if (!Object.keys(this.shipmentHelpers).length) {
      this.getShipmentHelpers()
    }
    if (!this.administrators.length) {
      this.getAllAdmins({ role_name: 'saler', limit: -1 })
    }
    this.$nextTick(() => {
      this.filter()
    })
  }
}
</script>
<style type="text/css" scoped>
.header {
  color: #333333;
  font-size: 18px;
  fill: #333333;
  margin-bottom: 0;
}

.sub-header {
  color: #666666;
  fill: #666666;
  font-size: 12px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?c986bf28